import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', () => {

    gsap.registerPlugin(SplitText, ScrollTrigger);

    document.fonts.ready.then(() => {

        // Sélection sécurisée
        const header = document.querySelector(".home .site-header__bottom");
        const subMenus = document.querySelectorAll(".home .sub-menu");
        const logo = document.querySelector(".home .site-header__bottom .widget-logo a img");
        const menuItems = document.querySelectorAll(".home .site-header .menu-item a");
        const navMobile = document.querySelectorAll(".home .hc-menu-toggle-icon");
        const containersCol = gsap.utils.toArray(".gsa-scroll-container");
        const widgets = gsap.utils.toArray(".gsa-scroll-container-widget .widget-widget_editeur");
        const containersBlocProduct = gsap.utils.toArray(".product-miniature__link");

        const mm = gsap.matchMedia();

        // Valeurs initiales (protégées)
        if (header)
            gsap.set(header, {
                background: "linear-gradient(180deg, rgb(0, 0, 0, 0.6), rgba(0, 0, 0, 0))",
                color: "#fff"
            });

        if (subMenus.length)
            gsap.set(subMenus, { backgroundColor: "transparent", color: "#fff" });

        if (menuItems.length)
            gsap.set(menuItems, {
                color: "#fff",
                textShadow: "0px 0px 10px rgba(0,0,0,0.4)"
            });

        if (logo)
            gsap.set(logo, { filter: "invert(1) brightness(2)" });

        if (navMobile.length)
            gsap.set(navMobile, { backgroundColor: "#fff" });

        // ScrollTrigger → état header
        ScrollTrigger.create({
            trigger: document.body,
            start: "top -350px",
            onEnter: () => {
                if (header)
                    gsap.to(header, {
                        background: "#fff",
                        color: "#3B3838",
                        duration: 0.3,
                        overwrite: true
                    });
            },
            onLeaveBack: () => {
                if (header)
                    gsap.to(header, {
                        background: "linear-gradient(180deg, rgb(0, 0, 0, 0.6), rgba(0, 0, 0, 0))",
                        color: "#fff",
                        duration: 0.3,
                        overwrite: true
                    });
            }
        });

        // ScrollTrigger → menus + logo
        ScrollTrigger.create({
            trigger: document.body,
            start: "top -350px",

            onEnter: () => {
                if (subMenus.length)
                    gsap.to(subMenus, { backgroundColor: "#fff", color: "#3B3838", duration: 0.3 });

                if (menuItems.length)
                    gsap.to(menuItems, { color: "#3B3838", textShadow: "0px 0px 0px rgba(0,0,0,0)", duration: 0.3 });

                if (logo)
                    gsap.to(logo, { filter: "invert(0) brightness(0)", duration: 0.3 });

                if (navMobile.length)
                    gsap.to(navMobile, { backgroundColor: "#3B3838", duration: 0.3 });
            },

            onLeaveBack: () => {
                if (subMenus.length)
                    gsap.to(subMenus, { backgroundColor: "transparent", color: "#fff", duration: 0.3 });

                if (menuItems.length)
                    gsap.to(menuItems, {
                        color: "#fff",
                        textShadow: "0px 0px 10px rgba(0,0,0,0.4)",
                        duration: 0.3 });

                if (logo)
                    gsap.to(logo, { filter: "invert(1) brightness(2)", duration: 0.3 });

                if (navMobile.length)
                    gsap.to(navMobile, { backgroundColor: "#fff", duration: 0.3 });
            }
        });

        // Mobile — duplication widget repeater
        mm.add("(max-width: 768px)", () => {
            const container = document.querySelector(".widget-repeater");
            if (!container) return; // <-- sécurité clé

            const items = [...container.children];

            if (!container.dataset.cloned) {
                items.forEach(item => {
                    const clone = item.cloneNode(true);
                    container.appendChild(clone);
                });

                container.dataset.cloned = "true";
            }

            const totalWidth = Array.from(container.children)
                .slice(0, items.length)
                .reduce((acc, el) => acc + el.offsetWidth, 0);

            const marquee = gsap.to(container, {
                x: `-${totalWidth}`,
                duration: 15,
                ease: "none",
                repeat: -1,
                modifiers: {
                    x: gsap.utils.unitize(x => {
                        let val = parseFloat(x);
                        if (val <= -totalWidth) val += totalWidth;
                        return val;
                    })
                }
            });

            return () => {
                marquee.kill();
                gsap.set(container, { x: 0 });
            };
        });

        // Animation colonnes
        containersCol.forEach(container => {
            if (!container) return;

            const cols = container.querySelectorAll(".col");
            if (!cols.length) return;

            gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: "top 90%",
                    toggleActions: "play none none reverse",
                }
            }).to(cols, {
                y: 0,
                autoAlpha: 1,
                duration: 1,
                ease: "power2.out",
                stagger: 0.2
            });
        });

        // Wrapper + animation widgets (UNE SEULE FOIS)
        widgets.forEach(widget => {
            if (!widget || widget.parentNode.classList.contains("anim-widget")) return;

            const wrapper = document.createElement("div");
            wrapper.classList.add("anim-widget");

            widget.parentNode.insertBefore(wrapper, widget);
            wrapper.appendChild(widget);

            gsap.to(widget, {
                scrollTrigger: {
                    trigger: wrapper,
                    start: "top 90%",
                    toggleActions: "play none none reverse"
                },
                y: 0,
                autoAlpha: 1,
                duration: 1,
                ease: "power2.out"
            });
        });

        // Animation blocs produits
        containersBlocProduct.forEach((container, i) => {
            if (!container) return;

            const blocsImgAnim = container.querySelectorAll(".product-miniature__images");
            const blocsTextAnim = container.querySelectorAll(".product-miniature__title");

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: "top 100%",
                    end: "bottom top",
                    toggleActions: "play reverse play reverse"
                },
                delay: i * 0.05
            });

            tl.fromTo(blocsImgAnim,
                { y: 80, autoAlpha: 0 },
                { y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.out" }
            ).fromTo(blocsTextAnim,
                { y: 80, autoAlpha: 0 },
                { y: 0, autoAlpha: 1, duration: 0.6, ease: "power2.out" },
                "<0.1"
            );
        });

    });
});
